import { Link } from 'react-router-dom';
import Cdi from '../assets/1.png';
import CdiUribicha from '../assets/2.png';
import Ninez from '../assets/3.png';
import Juventud from '../assets/4.png';
import fondoProgramas from '../assets/fondo3.png';
import FamiliasConProposito from '../assets/5.png';

const Areas = () => {
  const portfolios = [
    {
      id: 1,
      src: Cdi,
      tipo: 'Serie Documental',
      cliente: 'Visión mundial',
      route: '/supervivencia'
    },
    {
      id: 2,
      src: CdiUribicha,
      tipo: 'Spot Publicitario',
      cliente: 'Banco Fie',
      route: '/infancia'
    },
    {
      id: 3,
      src: Ninez,
      tipo: 'Película',
      cliente: 'Artistas Latinos',
      route: '/ninez'
    },
    {
      id: 4,
      src: Juventud,
      tipo: 'Serie Documental',
      cliente: 'Migafonos',
      route: '/juventud'
    },
    {
      id: 5,
      src: FamiliasConProposito,
      tipo: 'Serie Documental',
      cliente: 'Migafonos',
      route: '/familias'
    },
  ];

  return (
    <div
      name="programas"
      className="bg-green-two w-full text-white md:h-screen"
      style={{
        backgroundImage: `url(${fondoProgramas})`,
      }}
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8 flex flex-col justify-center items-center">
          <p className="text-3xl lg:text-5xl text-green-two font-montserrat font-bold inline justify-center border-b-4 border-orange-one">
            Áreas de acción
          </p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-1 px-12 sm:px-0">
          {portfolios.map(({ id, src, tipo, cliente, route }) => (
            <Link
              key={id}
              to={route}
              className="shadow-md shadow-gray-600 rounded-lg h-96 cursor-pointer"
            >
              <img
                src={src}
                alt={`${tipo} - ${cliente}`}
                className="rounded-md duration-200 hover:scale-110 h-full w-full"
              />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Areas;
